import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import integrationListStore from '../../stores/integrations-list-store';
import IntegrationCard from '../integration-card/integration-card';
import { Button } from '../../../../../components/inputs/button/button';
import { BUTTON_VARIANTS } from '../../../../../components/inputs/button-variants';
import IconPlus from '../../../../../components/icons/icon-plus/icon-plus';
import IntegrationTypeSelector from '../integration-type-selector/integration-type-selector';
import { IIntegrationStore } from '../../stores/integration-store';

interface IIntegrationsListProps {
    isExpanded?: boolean
}

const IntegrationsList: React.FC<IIntegrationsListProps> = observer(({ isExpanded = true }) => {
    const [isShowNewIntegration, setIsShowNewIntegration] = useState(false);

    useEffect(() => {
        integrationListStore.load();
    }, []);

    const toggleNewIntegration = () => {
        setIsShowNewIntegration(!isShowNewIntegration);
    };

    return (
        <>
            {integrationListStore.integrations &&
                integrationListStore.integrations.map((integration: IIntegrationStore, index: number) => (
                    <IntegrationCard
                        integration={integration}
                        isExpandable={true}
                        aggregatorsInfoStore={integrationListStore.aggregatorsStore}
                        isExpanded={isExpanded || integration.isNew()}
                        isButtonDisabled={integrationListStore.isLoading}
                        key={index}
                    />
                ))
            }
            {isShowNewIntegration && <IntegrationTypeSelector toggleNewIntegration={toggleNewIntegration} />}
            <div>
                <Button
                    disabled={isShowNewIntegration}
                    leftIcon={IconPlus}
                    variant={BUTTON_VARIANTS.Transparent}
                    text="Add product or service"
                    onClick={toggleNewIntegration}
                />
            </div>
        </>
    );
});

export default IntegrationsList;
